<template>
  <div class="settings-phone_status">
    <div class="flags ma-2">
      <flags />
    </div>
    <div class="call-forward ma-2">
      <call-forward />
    </div>
    <div class="follow-me ma-2">
      <followme />
    </div>
    <div class="toggle-destination ma-2">
      <toggle-dest />
    </div>
    <div class="blacklist-numbers ma-2">
       <blacklist-numbers />
    </div>
  </div>
</template>

<script>
import Flags from '@/components/settings/flags'
import CallForward from '@/components/settings/call_forward'
import Followme from '@/components/settings/followme'
import ToggleDest from '@/components/settings/toggle_dest'
import BlacklistNumbers from '@/components/settings/blacklist_numbers'

export default {
  name: 'settings-phone-status',
  components: {
    Flags,
    CallForward,
    Followme,
    ToggleDest,
    BlacklistNumbers
  }
}
</script>

<style>
</style>
